import React from 'react';
import { Link } from '@americanexpress/dls-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CheckboxField } from '@cim-ui/cim-shared';
const TermsAndConditions = () => {
  const {
    formatMessage
  } = useIntl();
  const TERMS_AND_CONDITIONS_URL = 'https://www.americanexpress.com/en-us/terms-and-conditions';
  const PRIVACY_POLICY_URL = 'https://www.americanexpress.com/en-us/privacy-statement';
  const termsAndConditionsLegendId = 'termsAndConditions-legend';
  const termsAndConditions = /*#__PURE__*/React.createElement(Link, {
    key: "terms-and-conditions",
    isInline: true,
    href: TERMS_AND_CONDITIONS_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.termsAndConditions.termsAndConditions"
  }));
  const privacyStatement = /*#__PURE__*/React.createElement(Link, {
    key: "privacy-statement",
    isInline: true,
    href: PRIVACY_POLICY_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.termsAndConditions.privacyStatement"
  }));
  const email = /*#__PURE__*/React.createElement(Link, {
    key: "support-email",
    isInline: true,
    href: `mailto:${formatMessage({
      id: 'general.support-email'
    })}`
  }, formatMessage({
    id: 'general.support-email'
  }));
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-labelledby": termsAndConditionsLegendId
  }, /*#__PURE__*/React.createElement("div", {
    id: termsAndConditionsLegendId,
    className: "sr-only"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.termsAndConditions.legend"
  })), /*#__PURE__*/React.createElement("div", {
    className: "row margin-responsive-b"
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    name: "acceptTermsAndConditions",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.termsAndConditions",
      values: {
        termsAndConditions,
        privacyStatement
      }
    }),
    className: "col-12"
  })), /*#__PURE__*/React.createElement("div", {
    className: "row margin-responsive-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 body-bold"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.termsAndConditions.hint",
    values: {
      email
    }
  }))));
};
export default TermsAndConditions;